import { Pipe, PipeTransform } from '@angular/core';

/**
 * Converts and interger(minutes) to text time
 *
 * __Usage :__
 *   value | durationToText
 *
 * __Example :__
 *   {{ 90 |  durationToText }}
 *   formats to: 1 hour 30 minutes
 *   {{ 90 |  durationToText:true }}
 *   formats to: 1h 30m
 *
 * Module {@link TransformDurationToTextModule}
 */
@Pipe({
    name: 'durationToText'
})

export class TransformDurationToTextPipe implements PipeTransform {
    transform(value: number|undefined, short = false): any {
        let returnText = '';

        if (value) {

            const hours = Math.floor(value / 60);
            const minutes = value % 60;

            if (hours > 0) {
                const hoursSyntax = short ? 'h ' : (hours === 1 ? ' hour ' : ' hours ');
                returnText = hours + hoursSyntax;
            }

            if (minutes > 0) {
                const minutesSyntax = short ? 'm' : (minutes === 1 ? ' minute' : ' minutes');
                returnText = returnText + minutes + minutesSyntax;
            }
        }

        return returnText.trim();
    }
}
